/* Filtrage collection 100% client (instantane, zero aller-retour serveur).
   V2 : toutes les cartes sont dans le DOM (paginate by 250), pagination client,
   compteurs sur l'index complet, tri global.
   Lit l'index JSON [data-cz-filter-index] rendu par main-collection.liquid, masque/affiche
   les <product-card> selon les filtres coches, recalcule compteurs + pills + tri, sync URL.
   Zero em-dash. */
(function () {
  'use strict';

  var idx = null;
  var cards = {};      // handle -> product-card element
  var order = [];      // ordre d'origine (handles)
  var filtered = [];   // handles filtres et tries (resultat courant)
  var currentPage = 1;
  var pageSize = 24;
  var GROUPS = {
    'filter.v.m.custom.couleur': 'colors',
    'filter.p.m.custom.materiel': 'materiel',
    'filter.p.m.custom.type_de_boucle': 'boucle',
    'filter.p.m.custom.taille_apple': 'models',
    'filter.p.m.custom.compat_bucket': 'models',
    'filter.p.m.custom.compat_garmin': 'models'
  };
  var num = function (v) { var m = ('' + v).match(/(\d+)\s*$/); return m ? m[1] : ('' + v); };

  function T(cle, repli) {
    var d = window.czI18n || {};
    return typeof d[cle] === 'string' && d[cle] !== '' ? d[cle] : repli;
  }

  function grid() { return document.querySelector('[data-ref="main-collection-products"] [data-ref="main-collection-grid"]'); }
  function forms() { return [].slice.call(document.querySelectorAll('[data-ref="filters-form"]')); }

  function parseIndex() {
    var el = document.querySelector('[data-cz-filter-index]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function buildCards() {
    cards = {}; order = [];
    [].forEach.call(document.querySelectorAll('[data-ref="main-collection-products"] product-card'), function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      cards[m[1]] = card;
      order.push(m[1]);
    });
    var g = grid();
    if (g && g.dataset.pageSize) pageSize = parseInt(g.dataset.pageSize, 10) || 24;
  }

  function readActive() {
    var a = { colors: [], materiel: [], boucle: [], models: [], gte: null, lte: null };
    var seen = {};
    forms().forEach(function (f) {
      [].forEach.call(f.querySelectorAll('input[type="checkbox"]:checked'), function (i) {
        var g = GROUPS[i.name]; if (!g) return;
        var v = g === 'colors' ? num(i.value) : i.value;
        var key = g + ':' + v;
        if (!seen[key]) { seen[key] = true; a[g].push(v); }
      });
      if (a.gte == null) {
        var gte = f.querySelector('[name="filter.v.price.gte"]');
        if (gte && gte.value !== '') a.gte = parseFloat(gte.value) * 100;
      }
      if (a.lte == null) {
        var lte = f.querySelector('[name="filter.v.price.lte"]');
        if (lte && lte.value !== '') a.lte = parseFloat(lte.value) * 100;
      }
    });
    return a;
  }

  function passGroup(d, a, skip) {
    if (!d) return true;
    if (skip !== 'price') {
      if (a.gte != null && !(d.pmax >= a.gte)) return false;
      if (a.lte != null && !(d.pmin <= a.lte)) return false;
    }
    if (skip !== 'colors' && a.colors.length) {
      var pc = (d.c || []).map(num);
      if (!a.colors.some(function (x) { return pc.indexOf(x) >= 0; })) return false;
    }
    /* 22/10 : un hybride compte dans ses deux matieres (m2 = custom.materiau_secondaire) */
    if (skip !== 'materiel' && a.materiel.length && a.materiel.indexOf(d.m) < 0 && (!d.m2 || a.materiel.indexOf(d.m2) < 0)) return false;
    if (skip !== 'boucle' && a.boucle.length) {
      var pb = d.b || [];
      if (!a.boucle.some(function (x) { return pb.indexOf(x) >= 0; })) return false;
    }
    if (skip !== 'models' && a.models.length) {
      var pm = d.mo || [];
      /* 22/10 : une montre a deux systemes envoie « v1,v2 » : un bracelet convient s'il porte l'une d'elles */
      if (!a.models.some(function (x) { return x.split(',').some(function (y) { return pm.indexOf(y) >= 0; }); })) return false;
    }
    return true;
  }

  /* 22/10/2026 : la page porte DEUX menus de tri (ordinateur et panneau mobile). Seul le premier etait lu,
     le tri choisi sur mobile ne s'appliquait donc jamais (audit du 22/10, cuir + prix croissant). Les menus
     sont maintenant tenus egaux et on lit leur valeur commune. */
  var sortChoisi = null;
  function sortSelects() { return [].slice.call(document.querySelectorAll('select[name="sort-by"]')); }
  function sortValue() {
    if (sortChoisi) return sortChoisi;
    var s = document.querySelector('select[name="sort-by"]');
    if (s && s.value) return s.value;
    return new URLSearchParams(location.search).get('sort_by') || 'manual';
  }

  function applySort(visibleHandles) {
    var sv = sortValue();
    var arr = visibleHandles.slice();
    if (sv === 'price-ascending') arr.sort(function (x, y) { return (idx[x].pmin || 0) - (idx[y].pmin || 0); });
    else if (sv === 'price-descending') arr.sort(function (x, y) { return (idx[y].pmin || 0) - (idx[x].pmin || 0); });
    else if (sv === 'title-ascending' || sv === 'title-descending') {
      arr.sort(function (x, y) {
        var tx = cards[x] ? (cards[x].textContent || '').trim().toLowerCase() : x;
        var ty = cards[y] ? (cards[y].textContent || '').trim().toLowerCase() : y;
        return tx < ty ? -1 : tx > ty ? 1 : 0;
      });
      if (sv === 'title-descending') arr.reverse();
    } else {
      arr.sort(function (x, y) { return order.indexOf(x) - order.indexOf(y); });
    }
    return arr;
  }

  function showPage(page) {
    var totalPages = Math.ceil(filtered.length / pageSize) || 1;
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    currentPage = page;

    var start = (page - 1) * pageSize;
    var end = Math.min(start + pageSize, filtered.length);

    for (var h in cards) {
      cards[h].style.display = 'none';
      cards[h].style.order = '';
    }

    for (var i = start; i < end; i++) {
      var handle = filtered[i];
      if (cards[handle]) {
        cards[handle].style.display = '';
        cards[handle].style.order = i - start + 1;
      }
    }

    renderPagination();
    updateBanner();
  }

  function renderPagination() {
    var ctn = document.querySelector('[data-cz-pagination]');
    if (!ctn) {
      var g = grid(); if (!g) return;
      ctn = document.createElement('nav');
      ctn.className = 'cz-pagination';
      ctn.setAttribute('data-cz-pagination', '');
      ctn.setAttribute('aria-label', T('pagination', 'Pagination'));
      g.parentNode.insertBefore(ctn, g.nextSibling);
    }

    var total = Math.ceil(filtered.length / pageSize);
    if (total <= 1) { ctn.innerHTML = ''; return; }

    var html = '';
    html += '<button class="cz-pagination__btn"' + (currentPage <= 1 ? ' disabled' : '') +
      ' data-cz-page="' + (currentPage - 1) + '" aria-label="' + T('page_prec', 'Page precedente') + '">' +
      '<svg width="7" height="12" viewBox="0 0 7 12"><path d="M6 1L1 6l5 5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button>';

    var pages = [];
    var i;
    if (total <= 7) { for (i = 1; i <= total; i++) pages.push(i); }
    else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (i = Math.max(2, currentPage - 1); i <= Math.min(total - 1, currentPage + 1); i++) pages.push(i);
      if (currentPage < total - 2) pages.push('...');
      pages.push(total);
    }
    pages.forEach(function (p) {
      if (p === '...') { html += '<span class="cz-pagination__dots">...</span>'; return; }
      html += '<button class="cz-pagination__btn' + (p === currentPage ? ' cz-pagination__btn--current' : '') +
        '" data-cz-page="' + p + '"' + (p === currentPage ? ' aria-current="page"' : '') + '>' + p + '</button>';
    });

    html += '<button class="cz-pagination__btn"' + (currentPage >= total ? ' disabled' : '') +
      ' data-cz-page="' + (currentPage + 1) + '" aria-label="' + T('page_suiv', 'Page suivante') + '">' +
      '<svg width="7" height="12" viewBox="0 0 7 12"><path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button>';

    ctn.innerHTML = html;
  }

  function updateBanner() {
    var countEls = document.querySelectorAll('[data-cz-count]');
    [].forEach.call(countEls, function (el) { el.textContent = filtered.length; });
  }

  function updateCounts(a) {
    var handles = Object.keys(idx);
    forms().forEach(function (f) {
      [].forEach.call(f.querySelectorAll('.cz-opt input[type="checkbox"]'), function (inp) {
        var g = GROUPS[inp.name]; if (!g) return;
        var val = g === 'colors' ? num(inp.value) : inp.value;
        var n = 0;
        for (var k = 0; k < handles.length; k++) {
          var d = idx[handles[k]]; if (!d) continue;
          if (!passGroup(d, a, g)) continue;
          var has;
          if (g === 'colors') has = (d.c || []).map(num).indexOf(val) >= 0;
          else if (g === 'materiel') has = d.m === val || d.m2 === val;
          else if (g === 'boucle') has = (d.b || []).indexOf(val) >= 0;
          else has = val.split(',').some(function (y) { return (d.mo || []).indexOf(y) >= 0; });
          if (has) n++;
        }
        var opt = inp.closest('.cz-opt');
        if (opt) {
          var cnt = opt.querySelector('.cz-opt__count');
          if (cnt) cnt.textContent = n;
          opt.classList.toggle('cz-opt--disabled', n === 0 && !inp.checked);
        }
      });
    });
  }

  /* Libelle lisible d'une case de filtre, cherche autour de la case elle-meme. */
  function optLabelLocal(inp) {
    var opt = inp.closest('.cz-opt');
    if (opt) {
      if (opt.getAttribute('data-cz-name')) return opt.getAttribute('data-cz-name');
      var l = opt.querySelector('.cz-opt__label'); if (l) return l.textContent.trim();
    }
    var fitem = inp.closest('.cz-finder__item');
    if (fitem) { var fn = fitem.querySelector('.cz-finder__name'); if (fn) return fn.textContent.trim(); }
    var lab = inp.closest('label');
    if (lab) {
      var txt = (lab.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) return txt;
    }
    var aria = inp.getAttribute('aria-label');
    if (aria && aria.trim()) return aria.trim();
    return '';
  }

  /* 21/09/2026 : la pastille au dessus de la grille affichait « gid://shopify/Metaobject/466288312584 »
     des qu'on cochait une couleur. Le filtre de couleur porte un metaobjet, sa valeur brute EST un
     identifiant, et le repli de cette fonction rendait cette valeur telle quelle. Le meme filtre est
     rendu plusieurs fois dans la page (colonne de bureau, panneau mobile, barre du theme) et un seul
     de ces rendus porte le libelle propre : on le cherche donc dans TOUTE la page, par nom et valeur,
     avant de renoncer. Et on n'affiche JAMAIS un identifiant brut a l'ecran. */
  /* 22/09/2026 : une pastille de couleur s'affiche dans sa couleur. Le rond de l'option porte la
     teinte en variable --sw ; on la relit dans toute la page, le meme filtre etant rendu plusieurs fois. */
  function swatchColor(inp) {
    var tous = document.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < tous.length; i++) {
      var j = tous[i];
      if (j.name !== inp.name || j.value !== inp.value) continue;
      var opt = j.closest('.cz-opt');
      var dot = opt && opt.querySelector('.cz-opt__dot');
      if (dot) {
        var c = (dot.style.getPropertyValue('--sw') || '').trim();
        if (c && c.toLowerCase() !== '#cccccc') return c;
      }
    }
    return '';
  }

  /* Texte noir sur fond clair, blanc sur fond sombre : sans ca « Blanc » devient illisible. */
  function texteLisible(hex) {
    var h = String(hex).replace('#', '').trim();
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return '#ffffff';
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return '#ffffff';
    return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#14181d' : '#ffffff';
  }

  function optLabel(inp) {
    var dico = window.czLibelles;
    if (dico) {
      var lu = dico[inp.name + '=' + inp.value];
      if (lu) return lu;
    }
    var direct = optLabelLocal(inp);
    if (direct) return direct;
    var tous = document.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < tous.length; i++) {
      var j = tous[i];
      if (j !== inp && j.name === inp.name && j.value === inp.value) {
        var lj = optLabelLocal(j);
        if (lj) return lj;
      }
    }
    if (String(inp.value).indexOf('gid://') === 0) return '';
    return inp.value;
  }

  function buildPills() {
    forms().forEach(function (f) {
      var checked = [].slice.call(f.querySelectorAll('input[type="checkbox"]:checked')).filter(function (i) { return GROUPS[i.name]; });
      var gte = f.querySelector('[name="filter.v.price.gte"]'), lte = f.querySelector('[name="filter.v.price.lte"]');
      var hasPrice = (gte && gte.value !== '') || (lte && lte.value !== '');
      var active = f.querySelector('.cz-active');
      if (!checked.length && !hasPrice) { if (active) active.remove(); return; }
      if (!active) {
        active = document.createElement('div');
        active.className = 'cz-active';
        f.insertBefore(active, f.firstChild);
      }
      active.innerHTML = '<div class="cz-active__pills"></div><a class="cz-active__clear" href="#" data-cz-clear></a>';
      active.querySelector('.cz-active__clear').textContent = T('reinit', 'Reinitialiser');
      var pills = active.querySelector('.cz-active__pills');
      checked.forEach(function (inp) {
        var etiq = optLabel(inp);
        if (!etiq) return;
        var p = document.createElement('button');
        p.type = 'button'; p.className = 'cz-active__pill'; p.setAttribute('data-cz-uncheck', '');
        p.dataset.name = inp.name; p.dataset.value = inp.value;
        var sw = swatchColor(inp);
        if (sw) {
          p.classList.add('cz-active__pill--sw');
          p.style.setProperty('--cz-sw', sw);
          p.style.setProperty('--cz-sw-text', texteLisible(sw));
        }
        p.innerHTML = '<span>' + etiq.replace(/</g, '&lt;') + '</span><span aria-hidden="true">&times;</span>';
        pills.appendChild(p);
      });
      if (hasPrice) {
        var sym = T('devise', '€');
        var lbl = gte.value && lte.value
          ? T('entre', '@@1 a @@2').replace('@@1', gte.value + sym).replace('@@2', lte.value + sym)
          : lte.value ? T('jusqu', 'Jusqu\'a @@').replace('@@', lte.value + sym)
          : T('apartir', 'A partir de @@').replace('@@', gte.value + sym);
        var pp = document.createElement('button');
        pp.type = 'button'; pp.className = 'cz-active__pill'; pp.setAttribute('data-cz-clear-price', '');
        pp.innerHTML = '<span>' + lbl + '</span><span aria-hidden="true">&times;</span>';
        pills.appendChild(pp);
      }
    });
  }


  function renderChips() {
    var ctn = document.querySelector('[data-cz-chips]');
    if (!ctn) return;
    var a = readActive();
    var hasAny = a.colors.length || a.materiel.length || a.boucle.length || a.models.length || a.gte != null || a.lte != null;
    if (!hasAny) { ctn.hidden = true; ctn.innerHTML = ''; return; }
    ctn.hidden = false;
    var html = '';
    var f0 = forms()[0];
    if (f0) {
      [].slice.call(f0.querySelectorAll('input[type="checkbox"]:checked')).filter(function (i) { return GROUPS[i.name]; }).forEach(function (inp) {
        var lbl = optLabel(inp);
        if (!lbl) return;
        lbl = lbl.replace(/</g, '&lt;');
        html += '<button type="button" class="cz-chip" data-cz-chip-remove data-name="' + inp.name + '" data-value="' + inp.value.replace(/"/g, '&quot;') + '">';
        html += '<span>' + lbl + '</span><span class="cz-chip__x" aria-hidden="true">&times;</span></button>';
      });
    }
    if (a.gte != null || a.lte != null) {
      var sym = T('devise', '\u20ac');
      var gv = '', lv = '';
      if (f0) {
        var ge = f0.querySelector('[name="filter.v.price.gte"]');
        var le = f0.querySelector('[name="filter.v.price.lte"]');
        if (ge) gv = ge.value; if (le) lv = le.value;
      }
      var lbl = gv && lv
        ? T('entre', '@@1 a @@2').replace('@@1', gv + sym).replace('@@2', lv + sym)
        : lv ? T('jusqu', 'Jusqu\'a @@').replace('@@', lv + sym)
        : T('apartir', 'A partir de @@').replace('@@', gv + sym);
      html += '<button type="button" class="cz-chip" data-cz-chip-price>';
      html += '<span>' + lbl + '</span><span class="cz-chip__x" aria-hidden="true">&times;</span></button>';
    }
    html += '<button type="button" class="cz-chips__clear" data-cz-chips-clear>' + T('effacer', 'Effacer') + '</button>';
    ctn.innerHTML = html;
  }

  function noResults(count) {
    var g = grid(); if (!g) return;
    var msg = g.querySelector('[data-cz-empty]');
    if (count === 0) {
      if (!msg) {
        msg = document.createElement('p');
        msg.setAttribute('data-cz-empty', '');
        msg.className = 'main-collection__empty';
        msg.style.gridColumn = '1 / -1';
        msg.textContent = T('aucun', 'Aucun produit ne correspond a ces filtres.');
        g.appendChild(msg);
      }
      msg.style.display = '';
    } else if (msg) { msg.style.display = 'none'; }
  }

  function syncURL() {
    var f = forms()[0]; if (!f) return;
    var p = new URLSearchParams();
    [].forEach.call(f.querySelectorAll('input[type="checkbox"]:checked'), function (i) { if (GROUPS[i.name]) p.append(i.name, i.value); });
    var gte = f.querySelector('[name="filter.v.price.gte"]'), lte = f.querySelector('[name="filter.v.price.lte"]');
    if (gte && gte.value !== '') p.set('filter.v.price.gte', gte.value);
    if (lte && lte.value !== '') p.set('filter.v.price.lte', lte.value);
    var sv = sortValue(); if (sv && sv !== 'manual') p.set('sort_by', sv);
    if (currentPage > 1) p.set('page', '' + currentPage);
    var hash = p.toString();
    var base = location.pathname + location.search;
    history.replaceState(null, '', hash ? base + '#' + hash : base);
  }

  var applying = false;
  function apply(keepPage) {
    if (!idx || applying) return;
    applying = true;
    try {
      var a = readActive();
      var visible = [];
      var allHandles = Object.keys(idx);
      for (var i = 0; i < allHandles.length; i++) {
        if (passGroup(idx[allHandles[i]], a, null)) visible.push(allHandles[i]);
      }
      visible = visible.filter(function (h) { return !!cards[h]; });
      filtered = applySort(visible);
      if (!keepPage) currentPage = 1;
      showPage(currentPage);
      updateCounts(a);
      buildPills();
      renderChips();
      noResults(filtered.length);
      syncURL();
    } finally {
      applying = false;
    }
  }

  function syncInput(src) {
    if (src.type === 'checkbox') {
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('input[name="' + (src.name || '').replace(/"/g, '') + '"]'), function (i) {
          if (i !== src && i.value === src.value && i.checked !== src.checked) i.checked = src.checked;
        });
      });
    } else if (/price/.test(src.name || '')) {
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('input[name="' + src.name + '"]'), function (i) { if (i !== src) i.value = src.value; });
      });
    }
  }

  function onChange(e) {
    var t = e.target;
    if (t && t.name === 'sort-by') {
      sortChoisi = t.value || 'manual';
      sortSelects().forEach(function (x) { if (x !== t) x.value = sortChoisi; });
      apply(); return;
    }
    if (!t || !(GROUPS[t.name] || /filter\.v\.price/.test(t.name || ''))) return;
    syncInput(t);
    apply();
  }

  function onClick(e) {
    var pgBtn = e.target.closest('[data-cz-page]');
    if (pgBtn) {
      e.preventDefault();
      var page = parseInt(pgBtn.dataset.czPage, 10);
      if (page >= 1) {
        showPage(page);
        syncURL();
        var g = grid();
        if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    var chipRm = e.target.closest('[data-cz-chip-remove]');
    if (chipRm) {
      e.preventDefault();
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('input[name="' + chipRm.dataset.name.replace(/"/g, '') + '"]'), function (i) { if (i.value === chipRm.dataset.value) i.checked = false; });
      });
      apply(); return;
    }
    var chipPrice = e.target.closest('[data-cz-chip-price]');
    if (chipPrice) {
      e.preventDefault();
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('[name="filter.v.price.gte"],[name="filter.v.price.lte"]'), function (i) { i.value = ''; });
      });
      [].forEach.call(document.querySelectorAll('[data-cz-price-slider-min]'), function (s) { s.value = 0; s.dispatchEvent(new Event('input', { bubbles: false })); });
      [].forEach.call(document.querySelectorAll('[data-cz-price-slider-max]'), function (s) { s.value = s.max; s.dispatchEvent(new Event('input', { bubbles: false })); });
      apply(); return;
    }
    var chipsClear = e.target.closest('[data-cz-chips-clear]');
    if (chipsClear) {
      e.preventDefault();
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('input[type="checkbox"]:checked'), function (i) { if (GROUPS[i.name]) i.checked = false; });
        [].forEach.call(f.querySelectorAll('[name="filter.v.price.gte"],[name="filter.v.price.lte"]'), function (i) { i.value = ''; });
      });
      [].forEach.call(document.querySelectorAll('[data-cz-price-slider-min]'), function (s) { s.value = 0; s.dispatchEvent(new Event('input', { bubbles: false })); });
      [].forEach.call(document.querySelectorAll('[data-cz-price-slider-max]'), function (s) { s.value = s.max; s.dispatchEvent(new Event('input', { bubbles: false })); });
      apply(); return;
    }

    var un = e.target.closest('[data-cz-uncheck]');
    if (un) {
      e.preventDefault();
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('input[name="' + un.dataset.name.replace(/"/g, '') + '"]'), function (i) { if (i.value === un.dataset.value) i.checked = false; });
      });
      apply(); return;
    }
    var cp = e.target.closest('[data-cz-clear-price]');
    if (cp) {
      e.preventDefault();
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('[name="filter.v.price.gte"],[name="filter.v.price.lte"]'), function (i) { i.value = ''; });
        var pr = f.querySelector('[data-cz-price]'); if (pr && window.__czBindPrice) { /* reset visuel */ }
      });
      [].forEach.call(document.querySelectorAll('[data-cz-price-slider-min]'), function (s) { s.value = 0; s.dispatchEvent(new Event('input', { bubbles: false })); });
      apply(); return;
    }
    var clr = e.target.closest('[data-cz-clear]');
    if (clr) {
      e.preventDefault();
      forms().forEach(function (f) {
        [].forEach.call(f.querySelectorAll('input[type="checkbox"]:checked'), function (i) { if (GROUPS[i.name]) i.checked = false; });
        [].forEach.call(f.querySelectorAll('[name="filter.v.price.gte"],[name="filter.v.price.lte"]'), function (i) { i.value = ''; });
      });
      [].forEach.call(document.querySelectorAll('[data-cz-price-slider-min]'), function (s) { s.value = 0; s.dispatchEvent(new Event('input', { bubbles: false })); });
      [].forEach.call(document.querySelectorAll('[data-cz-price-slider-max]'), function (s) { s.value = s.max; s.dispatchEvent(new Event('input', { bubbles: false })); });
      apply(); return;
    }
  }

  function isFilterKey(k) { return GROUPS[k] || /^filter\.v\.price/.test(k) || k === 'sort_by' || k === 'page'; }

  function handleLegacy() {
    var q = new URLSearchParams(location.search);
    var has = false; q.forEach(function (v, k) { if (isFilterKey(k)) has = true; });
    if (!has) return false;
    var keep = new URLSearchParams(), hp = [];
    q.forEach(function (v, k) { if (isFilterKey(k)) hp.push(k + '=' + encodeURIComponent(v)); else keep.set(k, v); });
    var ks = keep.toString();
    location.replace(location.pathname + (ks ? '?' + ks : '') + '#' + hp.join('&'));
    return true;
  }

  function applyFromState() {
    var p = new URLSearchParams(location.hash.replace(/^#/, ''));
    forms().forEach(function (f) {
      [].forEach.call(f.querySelectorAll('input[type="checkbox"]'), function (i) {
        if (!GROUPS[i.name]) return;
        i.checked = p.getAll(i.name).indexOf(i.value) >= 0;
      });
      var fg = f.querySelector('[name="filter.v.price.gte"]'), fl = f.querySelector('[name="filter.v.price.lte"]');
      if (fg) fg.value = p.get('filter.v.price.gte') || '';
      if (fl) fl.value = p.get('filter.v.price.lte') || '';
      if (fg) fg.dispatchEvent(new Event('input', { bubbles: false }));
      if (fl) fl.dispatchEvent(new Event('input', { bubbles: false }));
    });
    var sb = p.get('sort_by');
    sortChoisi = sb || 'manual';
    sortSelects().forEach(function (x) { x.value = sortChoisi; });
    var pg = parseInt(p.get('page'), 10);
    if (pg > 1) currentPage = pg;
  }

  function init() {
    if (handleLegacy()) return;
    idx = parseIndex();
    if (!idx) return;
    buildCards();
    for (var h in cards) cards[h].style.display = 'none';
    window.czInstant = { apply: apply, ready: true, filteredCount: function () { return filtered.length; } };
    document.addEventListener('change', onChange, false);
    document.addEventListener('click', onClick, false);
    window.addEventListener('hashchange', function () { applyFromState(); apply(true); });
    applyFromState();
    apply(true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
